import { rgba } from 'polished';
import {
  sideNavBaseStyle,
  TSideNavTheme,
} from '../../base/customComponents/sideNav';
import { TStyleConfig } from '../../base/types';

export const SideNav: TStyleConfig<TSideNavTheme> = {
  baseStyle: (props) => {
    const base = sideNavBaseStyle(props);

    return {
      ...base,

      readableColor: 'beta.500',

      background: {
        bg: ['beta.600', null, 'transparent'],
        borderRadius: 'lg',
        px: ['0', null, null, '5'],
        py: ['0', null, null, '3'],
        w: 'unset',
      },

      drawer: {
        ...base.drawer,
        label: 'drawer',
        gap: '2',
        maxW: ['100%', '370px', null, null],
      },
      drawerBody: {
        label: 'drawerBody',
        '> div, a': {
          ml: '0',

          '> .dropDownInner, a[class*="dropDownInner"]': {
            _first: {
              cursor: 'initial',
            },
            '&:hover, &:active': {
              bg: rgba(`${props.theme.colors.beta[500]}`, 0.8),
            },
          },
        },
        '&::-webkit-scrollbar': { display: 'none' },
      },
      icon: {
        ...base.icon,
        boxSize: '18px',
        mr: '2',
        filter: 'drop-shadow(0px 3px 4px rgba(0, 0, 0, 0.25))',
        color: 'alpha.400',
      },
      headerSX: {
        cursor: 'default',
        color: 'alpha.400',
        fontSize: 'sm',
        textShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
        height: '45px',
        borderBottom: '1px dashed rgba(0, 0, 0, 0.2)',
        _hover: {
          paddingLeft: '2',
          color: 'alpha.400',
        },
      },
      dropDownInner: {
        ...base.dropDownInner,
        color: 'white',
      },
      linkSX: {
        ...base.linkSX,
        borderRadius: 'none',
        mb: '0',
      },
      link: {
        ...base.link,
        textTransform: 'uppercase',
        fontSize: 'md',
        fontWeight: 'normal',
        height: '45px',
        color: 'alpha.400',
        fontFamily: 'accent',
        transition: 'all, 0.2s linear',
        borderTop: '1px dashed',
        borderTopColor: '#516397',
        borderBottom: '1px dashed',
        borderBottomColor: '#283455',
        textShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',

        ':first-child': {
          borderTop: 'none',
          textShadow: '0px 3px 4px rgba(0, 0, 0, 0.25)',
        },
        ':last-child': {
          borderBottom: 'none',
        },

        py: '3',
        px: ['0', null, null, '2'],
        ml: '0',

        '~ .nested': {
          pl: '0',
        },

        ':hover': {
          paddingLeft: '4',
          color: 'alpha.300',
        },

        ':active': {
          color: 'alpha.400',
          textShadow: '0px 0px 6px rgba(255, 202, 36, 0.6)',
        },

        '> .icon, .svgIcon, .dropDownIcon': {
          transition: 'all, 0.2s linear',
        },

        '.dropDownIcon': {
          fill: 'none',
        },
      },

      dropDownContainerClosed: {
        '.dropDownInner': {
          pl: ['0', null, null, '2'],
          borderBottom: '1px dashed rgba(0, 0, 0, 0.15)',
          borderTop: '1px dashed rgba(255, 255, 255, 0.15)',
        },

        '> a, .dropDownIcon, a': {
          color: 'alpha.100',
        },

        '&:hover, &:active': {
          '.dropDownInner': {
            label: 'dropDownInner',
            ...base.dropDownInner,
            h: '45px',
            px: ['3', null, null, '2'],
          },
        },
      },
      dropDownContainerOpen: {
        ...base.dropDownContainerOpen,

        p: '0',

        '.dropDownInner': {
          px: '2.5',
          color: 'alpha.400',
          bg: 'transparent',
          textShadow: '0px 0px 6px rgba(255, 202, 36, 0.6)',
          borderLeftWidth: '3px',
          borderLeftColor: 'alpha.400',
          borderBottom: '1px dashed rgba(0, 0, 0, 0.15)',
          borderTop: '1px dashed rgba(255, 255, 255, 0.15)',
          'svg:not(.dropDownIcon)': {
            fill: 'alpha.400',
            filter: 'drop-shadow(0px 0px 8px rgba(251, 201, 21, 0.50))',
          },
        },

        '> .icon, .svgIcon, .dropDownIcon': {
          color: 'alpha.400',
          filter: 'drop-shadow(0px 0px 8px rgba(251, 201, 21, 0.50))',
        },
      },
    };
  },
  sizes: {},
  variants: {},
};
